import React, { useEffect, useContext } from "react";
import { useReducerWithLogging } from "../utils/useReducerWithLogging";
import { steps } from "../utils/steps";
import { AppContextReducer, defaultAppState } from "../reducers/appContextReducer";
import { updateProgressStep } from "../actions/appActions";

const AppContext = React.createContext();

const useAppContext = () => useContext(AppContext);

const AppContextProvider = props => {
    const [state, dispatch] = useReducerWithLogging(AppContextReducer, defaultAppState);
    const { step } = state;

    //modify step when url changes
    useEffect(() => {
        const path = window.location.pathname;
        if (steps[step].url && steps[step].url !== path) {
            const targetStep = steps.find(item => item.url === path);
            let index = steps.indexOf(targetStep);
            index = index > -1 ? index : 0;
            dispatch(updateProgressStep(index));
        }
    }, [window.location.pathname]);
    return <AppContext.Provider value={{ state, dispatch }}>{props.children}</AppContext.Provider>;
};

const AppContextConsumer = AppContext.Consumer;

export { AppContext, AppContextProvider, AppContextConsumer, useAppContext };
